import { isMobile } from './checkMobile';

const applyViewportFix = () => {
  window.scrollTo(0, 0);
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;

  const h = window.visualViewport?.height ?? window.innerHeight;
  document.documentElement.style.setProperty('--vh', `${h * 0.01}px`);
};

/**
 * iOS 등 모바일에서 가상 키보드가 내려간 뒤 scroll offset / --vh가
 * 복구되지 않아 상단이 잘리고 하단 여백이 생기는 문제 방지.
 * visualViewport resize 시 1회만 --vh·scroll을 재계산한다.
 */
export const resetMobileViewportAfterKeyboard = () => {
  if (!isMobile()) return;

  (document.activeElement as HTMLElement | null)?.blur?.();

  const vv = window.visualViewport;
  if (vv) {
    let done = false;
    const finish = () => {
      if (done) return;
      done = true;
      vv.removeEventListener('resize', onResize);
      clearTimeout(fallback);
      applyViewportFix();
    };
    const onResize = () => finish();
    vv.addEventListener('resize', onResize);
    const fallback = setTimeout(finish, 400);
    return;
  }

  setTimeout(applyViewportFix, 300);
};
